export default __webpack_public_path__ + "static/media/mosaic5.3ed6462f.png";